export default {
      id: "publication-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#publication",
      toString: function () {
        return this.url;
      }
    }